import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const Divider: StyleRule = () => ({
    borderStyle: 'none none solid none',
    borderBottom: `1px solid #D2D2D0`,
    margin: pxArrayToRem([0, 18]),
});
